import { PropsWithChildren } from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

import { AssistantOrb } from '../AssistantOrb/AssistantOrb';

interface AssistantStatusProps extends PropsWithChildren {
  dataTestId?: string;
}

export function AssistantStatus({
  dataTestId = 'assistantStatus',
  children,
}: AssistantStatusProps) {
  return (
    <div
      role="status"
      data-testid={dataTestId}
      className="pointer-events-none fixed inset-x-0 top-0 z-30 flex flex-col items-center"
    >
      <div aria-hidden className="ai-beam h-1 w-full" />
      <div className="mt-16 px-4">
        <div
          className={cn(
            'flex items-center gap-3 rounded-full bg-surface-overlay-default py-3 pr-6 pl-4 shadow-lg',
            'text-sm font-medium stext-contrast-default',
            'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-top-2',
          )}
        >
          <AssistantOrb className="size-5" />
          <span>{children}</span>
        </div>
      </div>
    </div>
  );
}
